import { trimOrNull } from '@/utils/StringUtil';
import { convertFechaFin, convertFechaInicio } from './DateUtil';


export function required(value: any) {
  if(value){
  if (typeof value === 'string') return !!trimOrNull(value) || 'Requerido';
    else return !!value || 'Requerido';
    } else return 'Requerido'
}
export function maxLength(max: number) {
  return (value: string | number) => {
    if (!value) return true;
    if (typeof value === 'number') {
      value = value.toString();
    }
    return (value && value.length <= max) || `${max} caracteres máximo`;
  };
}
export function totalLength(length: number) {
  return (value: string | number) => {
    if (!value) return true;
    if (typeof value === 'number') {
      value = value.toString();
    }
    return (value && value.length == length) || `Debe ingresar ${length} dígitos`;
  };
}

export function maxDate(max: number) {
  return (value: string) =>
    (value && value.length <= max) || `${max} caracteres máximo`;
}

export function email(value: string) {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(value) || 'E-mail inválido';
}

export function cp(value: string) {
  return (value && value.length === 4) || 'Debe ingresar 4 dígitos';
}
export function lengthAnio(value: string | number) {
if(!value) return true
  if(typeof value !== 'string')   value = value.toString() 
  return ( value.length === 4) || 'Por favor, ingrese un año válido';
}
export function phone(value: string) {
  return (
    (value && value.length >= 8 && value.length <= 15) ||
    'Debe tener entre 8 y 15 dígitos'
  );
}

export function greaterOrEquals(fnMinValue: () => number | undefined) {
  return (value: number |  string ) => {
    if (!value || value === '') return true;
    const min: number | undefined = fnMinValue();
    if (!min) return true;
    return value >= min || 'El valor ingresado debe ser mayor o igual a ' + min;
  };
}

export function lessOrEquals(fnMaxValue: () => number | undefined) {
  return (value: number |  string) => {
    if (!value || value === '') return true;
    const max: number | undefined = fnMaxValue();
    if (!max) return true;
    return value <= max || 'El valor ingresado debe ser menor o igual a ' + max;
  };
}

export function validateCuit(cuit: string | number | undefined) {
  if (cuit) {
    if (typeof cuit !== 'string') {
      cuit = cuit.toString();
    }
    if (cuit.length !== 11) {
      return 'El CUIT/CUIL debe tener 11 dígitos';
    }

    let acumulado = 0;
    const digitos = cuit.split('');
    const digito = digitos.pop();

    for (let i = 0; i < digitos.length; i++) {
      acumulado += +digitos[9 - i] * (2 + (i % 6));
    }

    let verif = 11 - (acumulado % 11);
    if (verif === 11) {
      verif = 0;
    } else if (verif === 10) {
      verif = 9;
    }
    if (digito) {
      return +digito === verif || 'El CUIT/CUIL es incorrecto';
    } else return 'El CUIT/CUIL es incorrecto';
  } else return true;
}

export function greaterOrEqualsDates(fnMinValue: () => any | null) {
  return (value: string) => {
    const min: number | null = fnMinValue();
    if (!min) return true;
    if (!value) return true;
    return convertFechaFin(value).getTime() >= min || 'La fecha de fin debe ser igual o mayor a la fecha de inicio'
  };
}
export function greaterOrEqualsDatesEnd(fnMinValue: () => any | null) {
  return (value: string) => {
    const min: number | null = fnMinValue().value;
    const message = fnMinValue().message;
    if (!min) return true;
    if (!value) return true;
    return convertFechaFin(value).getTime() >= min || message
  };
}
export function greaterDates(fnMinValue: () => any | null) {
  return (value: string) => {
    const min: number | null = fnMinValue().value;
    const message = fnMinValue().message;
    if (!min) return true;
    if (!value) return true;
    return convertFechaInicio(value).getTime() > min || message
  };
}